import {getLastVersionName, getVersionNames} from 'powtoon-commons/json-versioning/utils'
export {initValidate, validate} from './01.13/index'

export const versions = {
  '00.00': () => import(/* webpackChunkName: 'document-schema-v00-00' */ './00.00'),
  '01.00': () => import(/* webpackChunkName: 'document-schema-v01-00' */ './01.00'),
  '01.01': () => import(/* webpackChunkName: 'document-schema-v01-01' */ './01.01'),
  '01.02': () => import(/* webpackChunkName: 'document-schema-v01-02' */ './01.02'),
  '01.03': () => import(/* webpackChunkName: 'document-schema-v01-03' */ './01.03'),
  '01.04': () => import(/* webpackChunkName: 'document-schema-v01-04' */ './01.04'),
  '01.05': () => import(/* webpackChunkName: 'document-schema-v01-05' */ './01.05'),
  '01.06': () => import(/* webpackChunkName: 'document-schema-v01-06' */ './01.06'),
  '01.07': () => import(/* webpackChunkName: 'document-schema-v01-07' */ './01.07'),
  '01.08': () => import(/* webpackChunkName: 'document-schema-v01-08' */ './01.08'),
  '01.09': () => import(/* webpackChunkName: 'document-schema-v01-09' */ './01.09'),
  '01.10': () => import(/* webpackChunkName: 'document-schema-v01-10' */ './01.10'),
  '01.11': () => import(/* webpackChunkName: 'document-schema-v01-11' */ './01.11'),
  '01.12': () => import(/* webpackChunkName: 'document-schema-v01-12' */ './01.12'),
  '01.13': () => import(/* webpackChunkName: 'document-schema-v01-13' */ './01.13')
}

export const latestVersion = getLastVersionName(getVersionNames(versions))